import actions from './actions';
import config from '../config';
import getters from './getters';
import mutations from './mutations';
import t from './types';

const initialState = () => ({
  categories: [],
  groups: [],
  events: [],
  eventFilter: null,
  eventRunners: null,
  fields: {},
  hash: null,
  info: {},
  metrics: {},
  presets: [],
  currentPreset: '',
  sort: config.sortOptions,
  currentSort: t.SORT_TIME,
  status: t.STARTING,
  count: 0,
  dayRange: 0,
  query: '',
  featuredPresets: config.featuredPresets,
  dateFilter: null,
});

export default {
  namespaced: true,
  state: initialState,
  actions,
  getters,
  mutations,
};
